export * from './access-dice.component';
export * from './module';
